import { PastaIcon } from './PastaIcon';

/**
 * author: Google
 * id 8288CA76-67E5-4EEA-82CD-DE0E0842F34D
 * name pasta
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pasta.svg
 * tags
 * - Food / Drink 
 */
export const FoodItalianIcon = PastaIcon;
export default FoodItalianIcon